

export default function Dashboard() {
    return (
        <div>Please use the navigation above to continue</div>
    )
}